import { Component, input, output } from '@angular/core';
import { CsIconModule } from '@components/icon';

export interface CartProductCardItem {
  title?: string;
  product?: { title?: string };
  quantityData?: string;
  mrp?: number;
  price?: number;
  quantity?: number;
  isRx?: boolean;
  isDoctorAdded?: boolean;
  rebrandedImageWithBackground?: string;
  rebrandedImage?: string;
  rebrandedImageWithoutBackground?: string;
  imageURL?: string;
}

// Default CD, not OnPush: parent mutates item fields in-place asynchronously, so signal inputs / computed() would miss updates.
@Component({
  selector: 'app-cart-product-card',
  templateUrl: './cart-product-card.component.html',
  imports: [CsIconModule],
})
export class CartProductCardComponent {
  item = input.required<CartProductCardItem>();
  nonRxLimit = input<number>(0);
  rxLimit = input<number>(0);

  viewDetail = output<void>();
  increment = output<void>();
  decrement = output<void>();
  remove = output<void>();

  // Empty (not undefined) when the item carries no artwork, so the template skips the <img> instead of requesting "undefined".
  get imageUrl(): string {
    const item = this.item();
    return item?.rebrandedImageWithBackground || item?.rebrandedImage || item?.rebrandedImageWithoutBackground || item?.imageURL || '';
  }

  get displayQuantity(): number {
    const item = this.item();
    const limit = item?.isRx ? this.rxLimit() : this.nonRxLimit();
    const quantity = item?.quantity ?? 0;
    return quantity > limit ? limit : quantity;
  }

  onViewDetail(): void {
    this.viewDetail.emit();
  }

  onIncrement(): void {
    this.increment.emit();
  }

  onDecrement(): void {
    this.decrement.emit();
  }

  onRemove(): void {
    this.remove.emit();
  }
}
